/*global require: false */
require(['jquery',
    'validate',
    'unobtrusive',
    'validateAll',
    'mvcFoolProofValidate'],

    function ($) {
        'use strict';

    $(document).ready(function () {

        $('#MembershipStatusSection').hide();
        $('#WhichPlanInterestedSection').hide();
        $('#HasMyAccountSection').hide();
        $('#SendMaterialSelection').hide();
        $('#ask_hmsa_infoYes').hide();
        $('#ask_hmsa_infoNo').hide();
        $("#submitform").hide();


        $('input[name=ReasonForInquiry]').change(function () {
            if ($('input[name=ReasonForInquiry]:checked').val() == 'HAVE_QUESTION') {
                $('#MembershipStatusSection').show();
                $('#HasMyAccountSection').hide();
                $('#WhichPlanInterestedSection').hide();
                $('#SendMaterialSelection').hide();
                $('#ask_hmsa_infoYes').hide();
                $('#ask_hmsa_infoNo').hide();
                $('#Contactinfo').hide();
                $("#Phoneno").hide('200');
                $("#Email").hide('200');
                $("#submitform").hide();
                $('#Addresssection').hide('200');
            }
            else {
                $('#HasMyAccountSection').hide();
                $('#WhichPlanInterestedSection').hide();
                $('#SendMaterialSelection').hide();
                $('#ask_hmsa_infoYes').hide();
                $('#ask_hmsa_infoNo').hide();

                $('input[name="MembershipStatus"]').prop('checked', false);
                $('input[name="WhichPlanInterested"]').prop('checked', false);

            }
        });

        $('input[name=ReasonForInquiry]:checked').trigger('change');

        $('input[name=ReasonForInquiry]').change(function () {
            if ($('input[name=ReasonForInquiry]:checked').val() == 'PLAN_MATERIAL') {
                $('#WhichPlanInterestedSection').show();
                $('#SendMaterialSelection').show();
                $('#Contactinfo').show();
                $("#Phoneno").hide('200');
                $("#submitform").show();
                $('#PrefferedContact').hide();
                $('#BestTime').hide();
                $('#MembershipStatusSection').hide();
                $('#HasMyAccountSection').hide();
                $('#ask_hmsa_infoYes').hide();
                $('#ask_hmsa_infoNo').hide();
                $('#Addresssection').hide('200');
                $('#Email').hide('200');
            }
            else {
                $('#HasMyAccountSection').hide();
                $('#WhichPlanInterestedSection').hide();
                $('#SendMaterialSelection').hide();
                $('#ask_hmsa_infoYes').hide();
                $('#ask_hmsa_infoNo').hide();

                $('input[name="SendMaterialSelection"]').prop('checked', false);
                $('input[name="WhichPlanInterested"]').prop('checked', false);

            }
        });

        $('input[name=ReasonForInquiry]:checked').trigger('change');

        $('input[name="MembershipStatus"]').change(function () {
            if ($('input[name=MembershipStatus]:checked').val() == 'HMSA_MEMBER') {
                $('#HasMyAccountSection').show();
                $('#WhichPlanInterestedSection').hide();
                $('#Contactinfo').hide();
                $("#Email").hide('200');
                $("#Phoneno").hide('200');
                $("#submitform").hide();
               
            } else if ($('input[name=MembershipStatus]:checked').val() == 'ENROLLING_HMSA_PLAN') { 
                $('#WhichPlanInterestedSection').show();
                $('#Contactinfo').show();
                $('#PrefferedContact').show();
                $('#BestTime').hide();
                $("#Email").show('200');
                $("#Phoneno").show('200');
                $("#submitform").show();
                $('#HasMyAccountSection').hide();
                $('#ask_hmsa_infoYes').hide();
                $('#ask_hmsa_infoNo').hide();
                $('#SendMaterialSelection').hide();

            } else { 
                $('#HasMyAccountSection').hide();
                $('#WhichPlanInterestedSection').hide();
                $('#Contactinfo').hide();
                $("#Phoneno").hide('200');
                $('#ask_hmsa_infoYes').hide();
                $('#ask_hmsa_infoNo').hide();
                $("#submitform").hide();
            }
        });

        $(document).ready(function () {
            function toggleBestTime() {
                if ($('#PreferredContact').val() == 'Phone') {
                    $('#BestTime').show();
                    $('#Addresssection').hide('200');
                } else if ($('#PreferredContact').val() == 'Mail') {
                    $('#Addresssection').show('200');
                    $('#BestTime').hide();
                }
                else {
                    $('#BestTime').hide();
                    $('#Addresssection').hide('200');
                }
            }
            $('#PreferredContact').change(toggleBestTime);
            toggleBestTime(); // in case of validation error reload
        });

        $('input[name="HasMyAccount"]').change(function () {
            if ($('#Yes').is(':checked')) {
                $('#ask_hmsa_infoYes').show();
                $('#ask_hmsa_infoNo').hide();
            } else if ($('#No').is(':checked')) {
                $('#ask_hmsa_infoYes').hide();
                $('#ask_hmsa_infoNo').show();
               
            } else {
                $('#ask_hmsa_infoYes').hide();
                $('#ask_hmsa_infoNo').hide();
            }

        });

        $('#SendMaterialSelection').change(function () {
            if ($('#SendPlanMaterialsEmail:checked').val() == 'EMAIL') {
                $('#Email').show('200');
                $('#PrefferedContact').hide();
                $('#Addresssection').hide('200');
                $("#Phoneno").hide('200');
            }
            else {
                if ($('#question:checked').val() != 'true') {
                    $('#Email').hide('200');
                    $("#Email").val('');
                }
            }
        });

        $('#SendMaterialSelection').change(function () {
            if ($('#SendPlanMaterialsMail:checked').val() == 'MAIL') {
                $('#Addresssection').show('200');
                $("#Phoneno").hide('200');

                if ($('#question:checked').val() != 'true') {
                    $('#Email').hide('200');
                    $("#Email").val('');
                }
            }
            else {
                $('#Addresssection').hide('200');
            }
        });
    });
   });
define("eutf-request-info", function(){});

